import {
    SUBJOBSTRUCTURE_FETCHING,
    SUBJOBSTRUCTURE_FAILED,
    SUBJOBSTRUCTURE_SUCCESS,
  } from "../actions/types";
  
  const initialState = {
    result: null,
    isFetching: false,
    isError: false,
  };
  
  export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case SUBJOBSTRUCTURE_FETCHING:
        return { ...state, result: null, isFetching: true, isError: false };
      case SUBJOBSTRUCTURE_FAILED:
        return { ...state, result: null, isFetching: false, isError: true };
      case SUBJOBSTRUCTURE_SUCCESS:
        return { ...state, result: payload, isFetching: false, isError: false };
      default:
        return state;
    }
  }
  